import React from 'react';
import {
  faClock,
  faFileAlt,
  faPlayCircle,
  faBuilding,
  faStar as faStarRegular,
  faUser as faUserRegular,
  faClone,
  faSquare,
  faCheckSquare,
  faCopy,
  faTrashAlt,
  faNewspaper,
  faEnvelope,
  faEyeSlash,
  faEye,
  faCalendarXmark,
  faCircleRight,
  faCircleCheck,
} from '@fortawesome/free-regular-svg-icons';
import {
  faCaretLeft,
  faCaretRight,
  faDownload,
  faUpload,
  faEuroSign,
  faPhone,
  faPencilAlt,
  faTimes,
  faExclamationCircle,
  faRocket,
  faBan,
  faChevronUp,
  faChevronDown,
  faTags,
  faPlusSquare,
  faUser,
  faUsers,
  faUserPlus,
  faStar,
  faGlobe,
  faCrosshairs,
  faComment,
  faSearch,
  faLock,
  faSort,
  faList,
  faCheckCircle,
  faSpinner,
  faWrench,
  faInfoCircle,
  faCheck,
  faUserTimes,
  faUserCheck,
  faMinusSquare,
  faSignOutAlt,
  faUserShield,
  faSortUp,
  faSortDown,
  faRotateRight,
  faTriangleExclamation,
  faMinus,
  faPlus,
  faCircleXmark,
  faEnvelopeCircleCheck,
  faExclamation,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';

import styled from 'styled-components';
import type { IconProps as CommonIconProps } from './Icon';
import { Icon } from './Icon';

type IconProps = Omit<CommonIconProps, 'icon'>

export type IconType = React.FC<IconProps>;

export const JoblistIcon: IconType = (props) => (
  <Icon {...props} icon={faFileAlt} />
);

export const NavigationLeftIcon: IconType = (props) => (
  <Icon {...props} icon={faCaretLeft} />
);

export const NavigationRightIcon: IconType = (props) => (
  <Icon {...props} icon={faCaretRight} />
);

export const AdratePriceIcon: IconType = (props) => (
  <Icon {...props} icon={faEuroSign} />
);

export const DownloadIcon: IconType = (props) => (
  <Icon {...props} icon={faDownload} />
);

export const UploadIcon: IconType = (props) => (
  <Icon {...props} icon={faUpload} />
);

export const PhoneIcon: IconType = (props) => (
  <Icon {...props} icon={faPhone} />
);

export const EmailIcon: IconType = (props) => (
  <Icon {...props} icon={faEnvelope} />
);

export const TimeIcon: IconType = (props) => (
  <Icon {...props} icon={faClock} />
);

export const VideoIcon: IconType = (props) => (
  <Icon {...props} icon={faPlayCircle} />
);

export const EditIcon: IconType = (props) => (
  <Icon {...props} icon={faPencilAlt} />
);

export const RemoveIcon: IconType = (props) => (
  <Icon {...props} icon={faMinusSquare} />
);

export const MinusToggleIcon: IconType = (props) => (
  <Icon {...props} icon={faMinus} />
);

export const PlusToggleIcon: IconType = (props) => (
  <Icon {...props} icon={faPlus} />
);

export const DeleteIcon: IconType = (props) => (
  <Icon {...props} icon={faTrashAlt} />
);

export const WarningIcon: IconType = (props) => (
  <Icon {...props} icon={faExclamationCircle} />
);

export const ActionsIcon: IconType = (props) => (
  <Icon {...props} icon={faRocket} />
);

export const BlacklistIcon: IconType = (props) => (
  <Icon {...props} icon={faBan} />
);

export const ColoredBlacklistIcon = styled(BlacklistIcon)`
  color: var(--color-attention);
`;

export const UnreachableIcon: IconType = (props) => (
  <Icon {...props} icon={faTriangleExclamation} />
);

export const ColoredUnreachableIcon = styled(UnreachableIcon)`
  color: var(--color-warning);
`;

export const MoreIcon: IconType = (props) => (
  <Icon {...props} icon={faChevronDown} />
);

export const LessIcon: IconType = (props) => (
  <Icon {...props} icon={faChevronUp} />
);

export const TagsIcon: IconType = (props) => (
  <Icon {...props} icon={faTags} />
);

export const MailingIcon: IconType = (props) => (
  <Icon {...props} icon={faEnvelope} />
);

export const MediumIcon: IconType = (props) => (
  <Icon {...props} icon={faBuilding} />
);

export const ContactIcon: IconType = (props) => (
  <Icon {...props} icon={faUserRegular} />
);

export const AddIcon: IconType = (props) => (
  <Icon {...props} icon={faPlusSquare} />
);

export const TenantIcon: IconType = (props) => (
  <Icon {...props} icon={faUser} />
);

export const TenantsIcon: IconType = (props) => (
  <Icon {...props} icon={faUsers} />
);

export const AddContactIcon: IconType = (props) => (
  <Icon {...props} icon={faUserPlus} />
);

export const CopyIcon: IconType = (props) => (
  <Icon {...props} icon={faCopy} />
);

export const CheckedIcon: IconType = (props) => (
  <Icon {...props} icon={faCheckSquare} />
);

export const UncheckedIcon: IconType = (props) => (
  <Icon {...props} icon={faSquare} />
);

export const FavoredIcon: IconType = (props) => (
  <Icon {...props} icon={faStar} />
);

export const UnfavoredIcon: IconType = (props) => (
  <Icon {...props} icon={faStarRegular} />
);

export const GeoIcon: IconType = (props) => (
  <Icon {...props} icon={faGlobe} />
);

export const RadiusIcon: IconType = (props) => (
  <Icon {...props} icon={faCrosshairs} />
);

export const FeedbackIcon: IconType = (props) => (
  <Icon {...props} icon={faComment} />
);

export const SearchIcon: IconType = (props) => (
  <Icon {...props} icon={faSearch} />
);

export const PrivateDataIcon: IconType = (props) => (
  <Icon {...props} icon={faLock} />
);

export const ColoredPrivateDataIcon = styled(PrivateDataIcon)`
  color: var(--color-gray-medium);
`;

export const SortIcon: IconType = (props) => (
  <Icon {...props} icon={faSort} />
);

export const SortUpIcon: IconType = (props) => (
  <Icon {...props} icon={faSortUp} />
);

export const SortDownIcon: IconType = (props) => (
  <Icon {...props} icon={faSortDown} />
);

export const DashboardIcon: IconType = (props) => (
  <Icon {...props} icon={faList} />
);

export const MailingTemplatesIcon: IconType = (props) => (
  <Icon {...props} icon={faClone} />
);

export const SuccessIcon: IconType = (props) => (
  <Icon {...props} icon={faCheckCircle} />
);

export const FailIcon: IconType = (props) => (
  <Icon {...props} icon={faExclamationCircle} />
);

export const LoadingIcon: IconType = (props) => (
  <Icon {...props} icon={faSpinner} pulse />
);

export const MaintenanceIcon: IconType = (props) => (
  <Icon {...props} icon={faWrench} />
);

export const InfoIcon: IconType = (props) => (
  <Icon {...props} icon={faInfoCircle} />
);

export const AcceptIcon: IconType = (props) => (
  <Icon {...props} icon={faCheck} />
);

export const RejectIcon: IconType = (props) => (
  <Icon {...props} icon={faTimes} />
);

export const CloseIcon: IconType = (props) => (
  <Icon {...props} icon={faTimes} />
);

export const NewsroomIcon: IconType = (props) => (
  <Icon {...props} icon={faNewspaper} />
);

export const ContactDesiredIcon: IconType = (props) => (
  <Icon {...props} icon={faUserCheck} />
);

export const NoContactDesiredIcon: IconType = (props) => (
  <Icon {...props} icon={faUserTimes} />
);

export const LogoutIcon: IconType = (props) => (
  <Icon {...props} icon={faSignOutAlt} />
);

export const AdminIcon: IconType = (props) => (
  <Icon {...props} icon={faUserShield} />
);

export const EyeIcon: IconType = (props) => (
  <Icon {...props} icon={faEye} />
);

export const EyeSlashIcon: IconType = (props) => (
  <Icon {...props} icon={faEyeSlash} />
);

export const RefreshIcon: IconType = (props) => (
  <Icon {...props} icon={faRotateRight} />
);

export const ExpiredIcon: IconType = (props) => (
  <Icon {...props} icon={faCalendarXmark} />
);

export const CircleRightIcon: IconType = (props) => <Icon {...props} icon={faCircleRight} />;
export const CircleXIcon: IconType = (props) => <Icon {...props} icon={faCircleXmark} />;
export const CircleCheckIcon: IconType = (props) => <Icon {...props} icon={faCircleCheck} />;
export const CircleExclamationIcon: IconType = (props) => <Icon {...props} icon={faCircleExclamation} />;

export const SenderDomainIcon: IconType = (props) => <Icon {...props} icon={faEnvelopeCircleCheck} />;

export const ExclamationIcon: IconType = (props) => <Icon {...props} icon={faExclamation} />;
